const { processConfig } = require('./configHelper');
const { deepFreeze } = require('../../utils/objectUtils');

let config;

const getLangcode = () =>
  typeof window === 'undefined'
    ? process.env.NATGEO_LANGCODE
    : window.NATGEO_LANGCODE;

const getHostConfig = () => ({
  isPreview: process.env.IS_PREVIEW
});

const getRawConfig = () =>
  typeof window === 'undefined'
    ? process.env.NATGEO_RAW_CONFIG
    : window.NATGEO_RAW_CONFIG;

const configNeedsReload = () => {
  if (config) {
    return process.env.NATGEO_CONF_RELOAD === 'true';
  }
  return true;
};

const getConfig = () => {
  if (configNeedsReload()) {
    process.env.NATGEO_CONF_RELOAD = 'false';
    const hostConfig = getHostConfig();
    const rawConfigString = getRawConfig();
    const rawConfig = JSON.parse(rawConfigString);
    const langcode = getLangcode();
    config = deepFreeze(processConfig(hostConfig, rawConfig, langcode));
  }
  return config;
};

const proxyHandler = {
  get(target, prop) {
    if (prop !== '$$typeof') {
      return getConfig()[prop];
    }
    // oxlint-disable-next-line prefer-rest-params
    return Reflect.get(...arguments);
  }
};

// const localeKeys = new Set();

const getLocale = key => {
  if (!config) {
    config = getConfig();
  }
  /*   if (!config.locale[key] && !localeKeys.has(key)) {
    localeKeys.add(key);
    throw new Error(`Missing locale key: ${key}`);
  } */
  return config.locale[key] || key;
};

module.exports = {
  // TODO: remove Proxy
  conf: new Proxy({}, proxyHandler),
  getHostConfig,
  t: getLocale
};
